var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.172 13.9992L12.636 11.4632L14.05 10.0492L19 14.9992L14.05 19.9492L12.636 18.5352L15.172 15.9992L8 15.9992C5.87827 15.9992 3.84343 15.1564 2.34314 13.6561C0.842852 12.1558 -1.90735e-06 10.1209 -1.90735e-06 7.99922C-1.90735e-06 5.87749 0.842852 3.84266 2.34314 2.34237C3.84343 0.842073 5.87827 -0.000782013 8 -0.000782013L19 -0.000782013L19 1.99922L8 1.99922C7.21207 1.99922 6.43185 2.15441 5.7039 2.45594C4.97594 2.75747 4.31451 3.19942 3.75736 3.75658C3.20021 4.31373 2.75825 4.97516 2.45672 5.70312C2.15519 6.43107 2 7.21129 2 7.99922C2 8.78715 2.15519 9.56736 2.45672 10.2953C2.75825 11.0233 3.20021 11.6847 3.75736 12.2419C4.31451 12.799 4.97594 13.241 5.7039 13.5425C6.43185 13.844 7.21207 13.9992 8 13.9992L15.172 13.9992Z",
    fill: "#56E4D7"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTag);
export default __webpack_public_path__ + "static/media/ArrowTag.9ba4006f087f38f4af6cf095291085a2.svg";
export { ForwardRef as ReactComponent };